import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numbersOnly]'
})
export class NumbersOnlyDirective {

  constructor(private element: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this.element.nativeElement.value;
    this.element.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
    if ( initalValue !== this.element.nativeElement.value) {
      event.stopPropagation();
    }
  }

}